import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { MedicalTagInput, medicalTagsApi } from '../tags';

export const medicalTagKeys = {
  all: ['medical', 'tags'] as const,
  list: () => [...medicalTagKeys.all] as const,
};

export function useTagsQuery() {
  return useQuery({
    queryKey: medicalTagKeys.list(),
    queryFn: () => medicalTagsApi.list(),
  });
}

export function useCreateMedicalTagMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: MedicalTagInput) => medicalTagsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: medicalTagKeys.list() }),
  });
}

export function useUpdateMedicalTagMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<MedicalTagInput> }) => medicalTagsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: medicalTagKeys.list() }),
  });
}

export function useDeleteMedicalTagMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => medicalTagsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: medicalTagKeys.list() }),
  });
}
